<template>
  <v-text-field
    type="text"
    :placeholder="label + (required && markRequired ? ' *' : '')"
    :value="value"
    @input="$emit('input', $event)"
    :rules="[...rules, validationRules.url]"
    outlined
    light
  />
</template>

<script>
import validationRulesMixin from "@/mixins/validation-rules.mixin";

export default {
  mixins: [validationRulesMixin],
  props: {
    label: String,
    value: String,
    rules: {
      type: Array,
      default: () => []
    },
    required: Boolean,
    markRequired: Boolean,
    addonData: {
      type: [Object, Boolean],
      default: false
    }
  }
};
</script>

<style></style>
